class AppController {
    constructor($rootScope) {
        this.$rootScope = $rootScope;
    }
}

export default AppController;
